export const CONFIG = {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  API_HOST: import.meta.env.VITE_API_HOST || '',
}
